module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTutorial),
      expression: "isTutorial"
    }]
  }, [_c('tutorial', {
    attrs: {
      "topic": _vm.tutorialTopic
    },
    on: {
      "onemore": _vm.oneMoreTutorial,
      "finish": _vm.finishTutorial
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTutorial),
      expression: "!isTutorial"
    }]
  }, [_c('div', {
    staticClass: "counter"
  }, [_c('span', [_vm._v("count: "), _c('span', {
    attrs: {
      "id": "score"
    }
  }, [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), _c('span', [_vm._v("highest: "), _c('span', {
    attrs: {
      "id": "high_score"
    }
  }, [_vm._v(_vm._s(_vm.highest))])])]), _vm._v(" "), _c('timer', {
    ref: "timer",
    attrs: {
      "limit": _vm.timeLimit
    },
    on: {
      "timeout": _vm.timeout
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReady),
      expression: "!isReady"
    }],
    attrs: {
      "id": "topic"
    }
  }, [_c('h1', {
    style: ({
      fontFamily: _vm.font
    }),
    attrs: {
      "id": "question"
    }
  }, [_vm._v(_vm._s(_vm.topic.question))]), _vm._v(" "), _vm._l((_vm.topic.choices), function(choice) {
    return _c('div', {
      staticClass: "choice",
      style: ({
        fontFamily: _vm.font
      }),
      on: {
        "click": function($event) {
          _vm.checkAnswer(choice)
        }
      }
    }, [_c('div', {
      class: {
        a: _vm.isPlaying
      }
    }, [_vm._v("\n          " + _vm._s(choice) + "\n          "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isGameOver),
        expression: "isGameOver"
      }]
    }, [(_vm.isCorrect(choice)) ? _c('i', {
      staticClass: "material-icons middle green"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons middle red"
    }, [_vm._v("clear")])])])])
  })], 2), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), (_vm.isGameOver && !_vm.submited) ? _c('div', [_vm._v("\n      Name:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "id": "name",
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu ripple middle",
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("send")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (_vm.isGameOver) ? _c('div', {
    staticClass: "menu ripple",
    on: {
      "click": _vm.replay
    }
  }, [_c('i', {
    staticClass: "material-icons middle"
  }, [_vm._v("replay")]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Re-Play")])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b71166ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 40
// module chunks = 0